import numeral from 'numeral';

const OPEN_STREET_MAP_GEOCODE_API_URL = (postalCode: string) =>
    `https://nominatim.openstreetmap.org/search?q=${postalCode},Nederland&format=json`;

export const getDistanceFromLatLngInMeters = (
    point1: LatLngModel,
    point2: LatLngModel,
) => {
    if (
        point1.lat === null ||
        point1.lng === null ||
        point2.lat === null ||
        point2.lng === null
    ) {
        return null;
    }

    const radlat1 = (Math.PI * point1.lat) / 180;
    const radlat2 = (Math.PI * point2.lat) / 180;
    const theta = point1.lng - point2.lng;
    const radtheta = (Math.PI * theta) / 180;

    let dist =
        Math.sin(radlat1) * Math.sin(radlat2) +
        Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = (dist * 180) / Math.PI;
    dist = dist * 60 * 1.1515;

    return Math.round(dist * 1.609344 * 1000);
};

export const getLatLngModelForPostalCode = async (postalCode: string) => {
    let formattedPostalCode = postalCode.replace(' ', '');
    if (formattedPostalCode.length >= 5) {
        formattedPostalCode =
            formattedPostalCode.slice(0, 4) +
            ' ' +
            formattedPostalCode.slice(4);
    }
    const response = await fetch(
        OPEN_STREET_MAP_GEOCODE_API_URL(formattedPostalCode),
        {
            headers: {
                'User-Agent':
                    'James Address Geocoder/0.1 (+https://www.jameshoreca.nl)',
            },
        },
    );

    if (response.ok) {
        const data = (await response.json())[0];

        if (data != null) {
            const latLngModel: LatLngModel = {
                lat: numeral(data.lat.replace('.', ',')).value(),
                lng: numeral(data.lon.replace('.', ',')).value(),
            };

            return latLngModel;
        }
    }

    const defaultLatLngModel: LatLngModel = {
        lat: null,
        lng: null,
    };

    return defaultLatLngModel;
};

export interface LatLngModel {
    lat: number | null;
    lng: number | null;
}
